import { APIClient } from "../api_helper";
import * as url from "../url_helper";

const api = new APIClient();

export const deviceSurveyAPI = (id, surveyId, stepId) => {
    return api.get(url.DEVICE_SURVEY(id, surveyId, stepId));
}
export const deviceSurveyStartAPI = id => {
    return api.create(url.DEVICE_SURVEY_START(id));
}

export const deviceSurveyStepAPI = (id, data) => {
    return api.create(url.DEVICE_SURVEY_STEP(id), data);
}

export const deviceSurveyPreviousStepAPI = (id, stepId) => {
    return api.get(url.DEVICE_SURVEY_PREVIOUS_STEP(id, stepId));
}
